module.exports = __webpack_public_path__ + "static/media/bgHome.2e7bcef0.png";